export enum ActionTempEnum {
  ONLY_JOURNAL,
  CONTR_VAL,
  CONST_TEMP,
}
